import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import moment from 'moment';
import SuggestedActions from 'components/dashboard/SuggestedActions';
import ManagerDashboardStore from 'stores/ManagerDashboardStore';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import {
  getManagerIdIfNotAuthUser,
  shouldUpdate,
  toDefaultPeriodBackInTime,
} from 'components/StatsPage2.utils';

const NUM_ACTIONS_SHOWN = 3;
export const widgetId = 'coaching-recommendations';

@connectToStores
export default class ManagerRecommendedCoaching extends React.Component {
  static getStores() {
    return [ManagerDashboardStore];
  }

  static getPropsFromStores() {
    const store = ManagerDashboardStore.getState();
    const {widgets, widgetState} = store;
    return {widgets, widgetState};
  }

  componentDidMount() {
    getCoachingRecommendations(
      widgetId,
      this.props.managerId,
      this.props.selectedTeam,
      this.props.numActionsShown
    );
  }

  componentDidUpdate(prevProps) {
    if (shouldUpdate(prevProps, this.props, true, false)) {
      getCoachingRecommendations(
        widgetId,
        this.props.managerId,
        this.props.selectedTeam,
        this.props.numActionsShown
      );
    }
  }

  render() {
    if (!this.props.widgets) {
      return null;
    }

    const widgetState = this.props.widgetState.get(widgetId);
    const widget = this.props.widgets.get(widgetId);

    if (!widget) {
      return <SuggestedActions recommendations={[]} listColumn={true} />;
    }

    const {startDate, endDate} = getStartDateInclusiveEndDateExclusive();

    return (
      <SuggestedActions
        key={widget.widgetId}
        widgetState={widgetState}
        coachId={this.props.coachId}
        managerId={this.props.managerId}
        adminId={this.props.adminId}
        refreshCoachingData={this.props.refreshCoachingData}
        numActionsShown={this.props.numActionsShown}
        listColumn={this.props.listColumn}
        title={this.props.title}
        suppressMascotCta={this.props.suppressMascotCta}
        {...widget}
        startDate={startDate}
        endDate={endDate}
        location={this.props.location}
      />
    );
  }
}

function getStartDateInclusiveEndDateExclusive() {
  const today = moment();
  const defaultPeriodBackInTime = toDefaultPeriodBackInTime(today);
  return {startDate: defaultPeriodBackInTime, endDate: today};
}

// Exporting this feels janky but I'd rather not duplicate it.
export function getCoachingRecommendations(widgetId, managerId, team, maxResults) {
  if (!team) {
    return;
  }

  const {startDate, endDate} = getStartDateInclusiveEndDateExclusive();

  const widgetConfig = {
    startDate,
    endDate,
    maxResults,
    teamId: team.id,
    widgetId: widgetId,
    widgetType: 'COACHING_RECOMMENDATIONS',
  };

  ManagerDashboardActions.getWidget.defer([widgetConfig, getManagerIdIfNotAuthUser({managerId})]);
}

ManagerRecommendedCoaching.defaultProps = {
  numActionsShown: NUM_ACTIONS_SHOWN,
};
